import { Header, Footer } from '@/shared/components/layout';
import { useDocumentTitle } from '@/shared/hooks';
import { Hero, HomepageSalesLetter } from './Components';

const HomePage = () => {
  useDocumentTitle('Buy REALTOR.ca Showing-Request Leads — BrokerMax');
  return (
    <div className="page font--jakarta">
      <Header />
      <Hero
        headline="REALTOR.ca showing requests · Ontario & Alberta"
        title="Buy individual showing-request leads in your territory"
        description={
          <>
            <p className="!mb-0">
              Not popup or ad-traffic leads — real buyers and renters who
              clicked <strong>Request a Showing</strong> on REALTOR.ca and are
              waiting for an agent to reach out.
            </p>
            <p className="mt-6 block w-full text-base opacity-90 !mb-0 md:mt-6">
              Available in Ontario &amp; Alberta.
            </p>
          </>
        }
        digits={[
          {
            value: '584',
            suffix: '',
            label: 'Motivated buyer & rental leads'
          },
          {
            value: '91',
            suffix: '%',
            label: 'Ready to buy or rent within 45-days'
          }
        ]}
        backgroundImage="/images/hero-8.jpg"
      />
      {/* <LeadQualitySection /> */}
      <HomepageSalesLetter />
      <Footer />
    </div>
  );
};

export default HomePage;
